import UserRoundReceived from '@components/v2/icons/UserRoundReceived';
import UserRoundSend from '@components/v2/icons/UserRoundSend';
import type { StatusChipProps } from '@components/v2/ui/StatusChip/StatusChip';
import { UserRound, UserRoundCheck, UserRoundX } from 'lucide-react';
import LangEnum from '../../../lang/LangEnum';
import { CustomerConnectionStatus } from '../types/customerConnectionStatus';

export const CONNECTION_STATUS_CHIP_CONFIG: Record<
  CustomerConnectionStatus,
  Omit<StatusChipProps, 'size'>
> = {
  CONVIDAR: { label: LangEnum.GLOBAL_NO_ACCESS_TO_TECEO, icon: UserRoundX, color: 'neutral' },
  CONECTAR: { label: LangEnum.GLOBAL_NOT_CONNECTED, icon: UserRound, color: 'neutral' },
  CONVITE_ENVIADO: {
    label: LangEnum.MY_NETWORK_STATUS_INVITED,
    icon: UserRoundSend,
    color: 'waiting',
  },
  CONVITE_RECEBIDO: {
    label: LangEnum.MY_NETWORK_STATUS_INVITE_RECEIVED,
    icon: UserRoundReceived,
    color: 'progress',
  },
  CONECTADO: { label: LangEnum.GLOBAL_CONNECTED, icon: UserRoundCheck, color: 'success' },
};
